import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';

const PORTAL_BASE =
   import.meta.env.VITE_PORTAL_BASE_URL || (window.location.hostname === 'app-staging.smartfi.ph' ? 'https://portal-staging.mysmartfi.ph' : 'https://portal.mysmartfi.ph');

function QrSticker() {
   const [params] = useSearchParams();
   const slug = params.get('slug') || '';
   const name = params.get('name') || 'Vendo';
   const auto = params.get('print') === '1';

   const url = `${PORTAL_BASE}/${slug}`;

   useEffect(() => {
      if (auto) {
         setTimeout(() => window.print(), 250);
      }
   }, [auto]);

   if (!slug) {
      return (
         <Page>
            <Card>
               <ErrorText>Missing slug parameter — open from the device card.</ErrorText>
            </Card>
         </Page>
      );
   }

   return (
      <Page>
         <NoPrint>
            <PrintBtn onClick={() => window.print()}>Print sticker</PrintBtn>
            <Hint>Tip: in the print dialog choose "Save as PDF" to download.</Hint>
         </NoPrint>

         <StickerCard>
            <Brand>SmartFi WiFi</Brand>
            <DeviceName>{name}</DeviceName>
            <QrWrap>
               <QRCodeSVG value={url} size={220} level="M" includeMargin={false} />
            </QrWrap>
            <Instr>Connect to WiFi → scan to open portal</Instr>
            <Url>{url}</Url>
         </StickerCard>
      </Page>
   );
}

export default QrSticker;

const Page = styled.div`
   min-height: 100vh;
   background: #f5f5f5;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 32px 16px;

   @media print {
      background: white;
      padding: 0;
   }
`;

const NoPrint = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 8px;
   margin-bottom: 24px;

   @media print {
      display: none;
   }
`;

const PrintBtn = styled.button`
   padding: 10px 24px;
   background: #3760f9;
   color: white;
   border: none;
   border-radius: 8px;
   font-size: 14px;
   font-weight: 600;
   cursor: pointer;

   &:hover {
      background: #2849d6;
   }
`;

const Hint = styled.p`
   font-size: 12px;
   color: #666;
`;

const StickerCard = styled.div`
   width: 320px;
   background: white;
   border: 2px solid #1a1a2e;
   border-radius: 16px;
   padding: 24px 20px;
   text-align: center;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

   @media print {
      box-shadow: none;
      page-break-inside: avoid;
   }
`;

const Brand = styled.div`
   font-size: 13px;
   font-weight: 700;
   letter-spacing: 1.5px;
   color: #3760f9;
   text-transform: uppercase;
   margin-bottom: 4px;
`;

const DeviceName = styled.h1`
   font-size: 20px;
   font-weight: 700;
   color: #1a1a2e;
   margin: 0 0 16px;
`;

const QrWrap = styled.div`
   display: flex;
   justify-content: center;
   margin-bottom: 16px;
`;

const Instr = styled.p`
   font-size: 13px;
   color: #555;
   margin: 0 0 8px;
`;

const Url = styled.p`
   font-size: 11px;
   font-family: 'SF Mono', 'Fira Code', monospace;
   color: #333;
   word-break: break-all;
   margin: 0;
`;

const ErrorText = styled.p`
   color: #c33;
   font-size: 14px;
`;

const Card = styled.div`
   background: white;
   padding: 24px;
   border-radius: 8px;
`;
